import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from "../Auth/AuthContext";

const SimpleDropdown = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);

    const Auth = useAuth();
    const user = Auth.authState.user;

    const toggleDropdown = () => setIsOpen((prev) => !prev);

    const handleOptionClick = async (option) => {
        if (option === 'Logout') {
            localStorage.removeItem("token");
            window.location.href = "/";
        } else if (option === 'Profile') {
            await fetchUserProfile();
        }
    };

    const fetchUserProfile = async () => {
        setLoading(true);
        try {
            const userId = user?.id;
            const baseUrl = process.env.REACT_APP_BASE_URL || 'https://localhost:44333/api/';
            const response = await fetch(`${baseUrl}Auth/GetUserProfile/${userId}`, {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            });

            if (!response.ok) throw new Error("Failed to fetch profile");

            const data = await response.json();
            setUserData(data);
            setIsModalOpen(true); // Open modal
        } catch (error) {
            console.error("Error fetching profile:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="relative inline-block text-left">
            {/* User Dropdown Button */}
            <button 
                onClick={toggleDropdown} 
                className="inline-flex w-full justify-center rounded-md bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 focus:outline-none"
            >
                <FontAwesomeIcon icon={faUser} className="text-gray-700 hover:text-gray-300" />
                <svg 
                    className="-mr-1 ml-2 h-5 w-5" 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 20 20" 
                    fill="currentColor" 
                    aria-hidden="true"
                >
                    <path 
                        fillRule="evenodd" 
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" 
                        clipRule="evenodd" 
                    />
                </svg>
            </button>

            {/* Dropdown Menu */}
            {isOpen && (
                <div className="absolute right-0 z-10 mt-2 w-40 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                    <div className="py-1">
                        <button 
                            onClick={() => handleOptionClick('Profile')} 
                            className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        >
                            {loading ? "Loading..." : "Profile"}
                        </button>
                        <button 
                            onClick={() => handleOptionClick('Logout')} 
                            className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        >
                            Logout
                        </button>
                    </div>
                </div>
            )}

            {/* Profile Modal */}
            {isModalOpen && userData && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
                    <div className="bg-white rounded-lg shadow-lg w-96 p-6">
                        <h2 className="text-xl font-bold text-gray-800 mb-4">User Profile</h2>
                        
                        <div className="grid gap-3">
                            <div>
                                <label className="text-gray-600 text-sm">Name:</label>
                                <input 
                                    type="text" 
                                    value={userData.name} 
                                    readOnly 
                                    className="w-full p-2 border rounded bg-gray-100"
                                />
                            </div>

                            <div>
                                <label className="text-gray-600 text-sm">Email:</label>
                                <input 
                                    type="text" 
                                    value={userData.email} 
                                    readOnly 
                                    className="w-full p-2 border rounded bg-gray-100"
                                />
                            </div>

                            <div>
                                <label className="text-gray-600 text-sm">Company:</label>
                                <input 
                                    type="text" 
                                    value={userData.company} 
                                    readOnly 
                                    className="w-full p-2 border rounded bg-gray-100"
                                />
                            </div>

                            <div>
                                <label className="text-gray-600 text-sm">Phone:</label>
                                <input 
                                    type="text" 
                                    value={userData.phone} 
                                    readOnly 
                                    className="w-full p-2 border rounded bg-gray-100"
                                />
                            </div>

                            <div>
                                <label className="text-gray-600 text-sm">Invoice Enabled:</label>
                                <input 
                                    type="text" 
                                    value={userData.isInvoiceEnable ? "Yes" : "No"} 
                                    readOnly 
                                    className="w-full p-2 border rounded bg-gray-100"
                                />
                            </div>

                            <div>
                                <label className="text-gray-600 text-sm">Approved By Admin:</label>
                                <input 
                                    type="text" 
                                    value={userData.isApprovedByAdmin ? "Yes" : "No"} 
                                    readOnly 
                                    className="w-full p-2 border rounded bg-gray-100"
                                />
                            </div>
                        </div>

                        {/* Close Button */}
                        <div className="mt-4 flex justify-end">
                            <button 
                                onClick={() => setIsModalOpen(false)} 
                                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SimpleDropdown;
